<script>
    export let alertMessage = "";
    export let alertType = "error"; // "error", "success", "info"
  </script>
  
  <div class="alert-bar {alertType}">
    <p>{alertMessage}</p>
  </div>
  
  <style>
    .alert-bar {
      position: fixed;
      top: 60px;
      width: 100%;
      z-index: 9999;
      padding: 0.75rem;
      text-align: center;
      font-size: 1rem;
      font-weight: 500;
      color: #fff;
      background-color: #ff4c4c; /* default error color */
      border-bottom: 2px solid #ff6b6b;
      animation: slideDown 0.3s ease forwards;
    }
    .alert-bar.success {
      background-color: #4caf50;
      border-bottom-color: #43a047;
    }
    .alert-bar.info {
      background-color: #2196f3;
      border-bottom-color: #1e88e5;
    }
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  </style>
  